var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.79289 0.707106C4.18342 0.316582 4.81658 0.316583 5.20711 0.707107L8.29289 3.79289C8.68342 4.18342 8.68342 4.81658 8.29289 5.20711L5.20711 8.29289C4.81658 8.68342 4.18342 8.68342 3.79289 8.29289L0.707106 5.20711C0.316582 4.81658 0.316583 4.18342 0.707107 3.79289L3.79289 0.707106Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletIcon);
export default __webpack_public_path__ + "static/media/bulletIcon.16cc4462fe3cbcb0c4cb418425436d68.svg";
export { ForwardRef as ReactComponent };